import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: "",
  controller_code: "",
  customer_scope: "",
  //TODO pageData property
  // pageData: {
  // },
  form: {
    title: "",
    first_name: "",
    last_name: "",
    type: "",
    value: "",
    language: "",
    contact_email: "",
    recordType: "",
  },
  form_type: "",
  identity_search: {
    type: "",
    value: "",
  },
  content_search: {
    value: "",
  },
  modal_type: "",
  active_tab: "",
  content_environment: "",
};

export const TrackerSlice = createSlice({
  name: "Tracker",
  initialState,
  reducers: {
    addTrackedDetails: (state, action) => {
      // Update relevant parts of the state based on the action payload
      const {
        controller_code,
        customer_scope,
        form,
        form_type,
        identity_search,
        content_search,
        modal_type,
        active_tab,
        content_environment,
        delete_form,
      } = action.payload;
      // You can update specific fields in the state
      state.page = window.location.pathname;
      if (controller_code !== undefined)
        state.controller_code = controller_code;
      if (customer_scope !== undefined) state.customer_scope = customer_scope;

      if (form) {
        state.form = { ...state.form, ...form }; // Merge form data
      }

      if (form_type !== undefined) state.form_type = form_type;

      if (identity_search) {
        state.identity_search = {
          ...state.identity_search,
          ...identity_search,
        }; // Merge identity_search data
      }

      if (content_search) {
        state.content_search = { ...state.content_search, ...content_search }; // Merge content_search data
      }

      if (modal_type !== undefined) state.modal_type = modal_type;
      if (active_tab !== undefined) state.active_tab = active_tab;
      if (content_environment !== undefined)
        state.content_environment = content_environment;
      if (delete_form) state.delete_form = delete_form;
    },
    updateTracker: (state, action) => {
      const obj = action?.payload;
      return { ...state, ...obj };
    },
  },
});
export const { addTrackedDetails, updateTracker } = TrackerSlice.actions;
export default TrackerSlice.reducer;
